import { render, staticRenderFns } from "./IconPdv.vue?vue&type=template&id=456c7ece&scoped=true"
import script from "./IconPdv.vue?vue&type=script&lang=js"
export * from "./IconPdv.vue?vue&type=script&lang=js"
import style0 from "./IconPdv.vue?vue&type=style&index=0&id=456c7ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456c7ece",
  null
  
)

export default component.exports